export default __webpack_public_path__ + "static/media/bundle-coach-aok-northwest@2x.97aa90f5.webp";